module.exports = __webpack_public_path__ + "img/construction-product-cym.21fb1077.png";